import getConsumerMailboxOperation from 'owa-service/lib/operation/getConsumerMailboxOperation';
import GetConsumerMailboxRequest from 'owa-service/lib/contract/GetConsumerMailboxRequest';
import GetConsumerMailboxResponse from 'owa-service/lib/contract/GetConsumerMailboxResponse';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';

export async function getConsumerMailbox(): Promise<GetConsumerMailboxResponse> {
    let request: GetConsumerMailboxRequest = {
        Header: getJsonRequestHeader(),
    };

    let response: GetConsumerMailboxResponse = await getConsumerMailboxOperation(request);
    return response;
}
